import { Component, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core'
import { WindowRef } from '@spartacus/core'
import { BehaviorSubject, Subject } from 'rxjs'
import { debounceTime } from 'rxjs/operators'

declare type DropdownAlignment = 'left' | 'center' | 'right'

@Component({
    selector: 'eb-dropdown',
    templateUrl: './eb-dropdown.component.html',
    styleUrls: ['./eb-dropdown.component.scss'],
    standalone: false
})
export class EbDropdownComponent {
  @Output() collapsed = new EventEmitter()
  @Output() expanded = new EventEmitter()
  @Input() alignment: DropdownAlignment | 'auto' = 'auto'

  resize$ = new BehaviorSubject(undefined)
  alignmentClassname$ = new Subject<DropdownAlignment>()
  expanded$ = new BehaviorSubject(false)
  private readonly window: Window
  private readonly element: HTMLElement

  constructor(winRef: WindowRef, elementRef: ElementRef) {
    if (this.alignment === 'auto') {
      this.window = winRef.nativeWindow
      this.element = elementRef.nativeElement
      this.resize$.pipe(debounceTime(100)).subscribe(() => {
        this.calculateDirection()
      })
    } else {
      this.alignmentClassname$.next(this.alignment)
    }
  }

  onClick() {
    const isExpanded = this.expanded$.getValue()
    this.expanded$.next(!isExpanded)
    if (isExpanded) {
      this.collapsed.emit()
    } else {
      this.expanded.emit()
    }
  }

  onBlur() {
    this.expanded$.next(false)
    this.collapsed.emit()
  }

  @HostListener('window:resize')
  private onResize() {
    this.resize$.next(undefined)
  }

  private calculateDirection(): void {
    const viewportWidth = this.window.innerWidth
    const boundingClientRect = this.element.getBoundingClientRect()
    const elementCenter = boundingClientRect.x + boundingClientRect.width / 2
    let alignment: DropdownAlignment = 'center'
    if (elementCenter < viewportWidth / 3) {
      alignment = 'left'
    } else if (elementCenter > (viewportWidth * 2) / 3) {
      alignment = 'right'
    }
    this.alignmentClassname$.next(alignment)
  }
}
